<template>
  <div class="courses-container">
    <div>
      <top-bar
        :teachers="school_teachers"
        @filters="searchAndFilters"
        @admin-portal-filter-changed="resetFilters"
      />
    </div>
    <div>
      <courses-table
        :coursesList="courses"
        :teachers="school_teachers"
        :loading="loading"
        :schoolCoursesCount="schoolCoursesCount"
        @scroll-on-table="handleScroll(page_number)"
        @updateNumberOfCourses="updateNumberOfCourses"
      />
    </div>
    <div class="row w-100 center-xs">
      <div v-if="loading_table_body">
        <pl-spinner class="x5" />
      </div>
    </div>
  </div>
</template>

<script>
  import CoursesTable from './coursesTable.vue';
  import topBar from './topBar.vue';
  import { EventBus } from 'utils/event-bus';
  import adminServices from 'services/admin/adminServices';

  export default {
    components: { topBar, CoursesTable },
    data() {
      return {
        courses: [],
        loading: false,
        school_teachers: [],
        page_number: 1,
        filters: {
          course_title: '',
          user_ids: [],
          page: 1,
        },
        show_more_courses: true,
        loading_table_body: false,
        courses_page_size: 20,
        schoolCoursesCount: 0,
      };
    },
    methods: {
      getCoursesFromSchool(page, schoolID, is_filter, onScroll) {
        if (!onScroll) {
          this.loading = true;
        } else {
          this.loading_table_body = true;
        }

        if (is_filter) {
          this.courses = [];
        }

        this.filters.page = page;

        adminServices
          .getSchoolCourses(schoolID, this.filters)
          .then(({ data }) => {
            if (data && data.school_courses.length > 0) {
              if (this.page_number === 1) {
                this.schoolCoursesCount = data.school_courses_count;
              }
              this.courses.push(...data.school_courses);
              if (data.school_courses.length === this.courses_page_size) {
                this.page_number += 1;
              } else {
                this.show_more_courses = false;
              }
            } else {
              this.show_more_courses = false;
            }
          })
          .catch((error) => {
            console.log(error);
            EventBus.$emit('toast-msg', 'Failure. Please try again.');
          })
          .finally(() => {
            this.loading = false;
            this.loading_table_body = false;
          });
      },
      getTeachersFromSchool(schoolID) {
        adminServices.getTeachersOfSchool(schoolID).then(({ data }) => {
          this.school_teachers = data;
        });
      },
      searchAndFilters(filters) {
        const { schoolID } = this.$route.params;
        this.filters = filters;
        this.getCoursesFromSchool(this.page_number, schoolID, true);
      },
      resetFilters() {
        this.courses = [];
        this.show_more_courses = true;
        this.page_number = 1;
      },

      elementHasReachedScrollEnd(elementId) {
        const element = document.getElementById(elementId);
        return (
          element.scrollHeight - Math.floor(element.scrollTop) ===
            element.clientHeight ||
          element.scrollHeight - Math.round(element.scrollTop) ===
            element.clientHeight
        );
      },
      handleScroll(page_number) {
        const { schoolID } = this.$route.params;
        if (
          this.elementHasReachedScrollEnd('admin-portal-course-table') &&
          this.show_more_courses
        ) {
          this.getCoursesFromSchool(page_number, schoolID, false, true);
        }
      },
      updateNumberOfCourses(array) {
        array.forEach((el) => {
          const index = this.courses.findIndex((c) => c.id === el.id);
          if (index !== -1) {
            this.courses.splice(index, 1);
          }
        });
        this.schoolCoursesCount -= array.length;
      },
    },
    mounted() {
      const { schoolID } = this.$route.params;

      this.getCoursesFromSchool(this.page_number, schoolID);
      this.getTeachersFromSchool(schoolID);

      EventBus.$on('getSchoolCourses', () => {
        this.getCoursesFromSchool(this.page_number, schoolID);
      });
      EventBus.$on('updateCoursesList', () => {
        this.resetFilters();
        this.getCoursesFromSchool(this.page_number, schoolID);
      });
      EventBus.$on('showCoursesAddedModal', () => {
        EventBus.$emit('toast-msg', 'Successfully added new courses!');
      });
    },
    beforeDestroy() {
      EventBus.$off('updateCoursesList');
      EventBus.$off('getSchoolCourses');
      EventBus.$off('updateCoursesList');
      EventBus.$off('showCoursesAddedModal');
    },
  };
</script>

<style lang="stylus" scoped>
  @import '~app/global-stylus.styl';

  .courses-container
    padding: 3.1rem 2rem 0 2rem
</style>



// WEBPACK FOOTER //
// adminPortalCourses.vue?9366e704